import React from "react";
import "../../Styles/certified/walkzero.css";

export default function Walkzero() {
  return (
    <div className="walkzero-certified-details-section">
      <div className="walkzero-certified-details-title">
        OUTSTANDING WORKPLACES CERTIFIED COMPANIES
      </div>

      <div className="walkzero-certified-details-container">
        <div className="walkzero-certified-details-left">
          <img
            src="/assets/walkzero/april_2026.png"
            alt="Outstanding Workplaces Certified"
            className="walkzero-certified-badge"
          />
          <div className="walkzero-certified-company-names">
            <a href="https://www.walkzero.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/walkzero/walk.png"
                alt="Walkzero Logo"
                className="walkzero-certified-company-logo"
              />
            </a>
            <h1 className="walkzero-certified-full-name">
              Walkzero Technologies Private Limited
            </h1>
          </div>
        </div>

        <div className="walkzero-certified-details-right">
          <img
            src="/assets/walkzero/walkzero_1.JPG"
            alt="Walkzero Office"
            className="walkzero-certified-company-image"
          />
        </div>
      </div>

      <div className="walkzero-certified-description">
        <h2>Why Walkzero Technologies Private Limited is a Outstanding Workplaces</h2>
        <p>
          About Walkzero – Our Flagship Product, Walkzero is more than an HR
          platform. It's a people operating system designed for the modern
          workplace. Built from firsthand founder experience, Walkzero was
          created to solve the chaos that growing companies face — scattered
          processes, unclear accountability, time leaks, and disengaged teams.
          We lived those problems. So we fixed them.
        </p>
      </div>

      <div className="walkzero-certified-info-cards">
        <div className="walkzero-certified-info-card">
          <div className="walkzero-certified-info-title">COMPANY SIZE</div>
          <div className="walkzero-certified-info-value">27+ Employees</div>
        </div>
        <div className="walkzero-certified-info-card">
          <div className="walkzero-certified-info-title">INDUSTRY</div>
          <div className="walkzero-certified-info-value">Information Technology</div>
        </div>
        <div className="walkzero-certified-info-card">
          <div className="walkzero-certified-info-title">CONNECT</div>
          <div className="walkzero-certified-info-icons">
            <a href="https://www.walkzero.com" target="_blank" rel="noopener noreferrer" className="walkzero-certified-icon-round">
              <img src="/assets/website.png" alt="Website" />
            </a>
            <a href="https://www.linkedin.com/company/walkzero" target="_blank" rel="noopener noreferrer" className="walkzero-certified-icon-round">
              <img src="/assets/linkedin.png" alt="LinkedIn" />
            </a>
            <a href="https://www.facebook.com/walkzero/" target="_blank" rel="noopener noreferrer" className="walkzero-certified-icon-round">
              <img src="/assets/facebook.png" alt="Facebook" />
            </a>
            <a href="https://twitter.com/walkzero" target="_blank" rel="noopener noreferrer" className="walkzero-certified-icon-round">
              <img src="/assets/x.png" alt="X" />
            </a>
          </div>
        </div>
        <div className="walkzero-certified-info-card">
          <div className="walkzero-certified-info-title">LOCATION (HQ)</div>
          <div className="walkzero-certified-info-value">Chennai</div>
        </div>
      </div>

      <div className="walkzero-certified-recognition-section">
        <h2 className="walkzero-certified-recognition-title">
          Recognitions awarded by Outstanding Workplaces
        </h2>
        <div className="walkzero-certified-recognition-badge">
          <img
            src="/assets/walkzero/april_2026.png"
            alt="Outstanding Workplaces Certified"
            className="walkzero-certified-recognition-image"
          />
        </div>
        <div className="walkzero-certified-recognition-label">
          Outstanding Workplaces - Certified
        </div>
      </div>

      <div className="walkzero-certified-life-section">
        <h2 className="walkzero-certified-life-title">
          Life at Walkzero Technologies Private Limited
        </h2>
        <div className="walkzero-certified-life-gallery">
          <div className="walkzero-certified-life-col">
            <img src="/assets/walkzero/walkzero_4.jpeg" alt="Office 1" className="walkzero-certified-life-img" />
            <img src="/assets/walkzero/walkzero_2.JPG" alt="Meeting 1" className="walkzero-certified-life-img" />
          </div>
          <div className="walkzero-certified-life-col walkzero-certified-life-center">
            <img src="/assets/walkzero/walkzero_3.jpg" alt="Main Office" className="walkzero-certified-life-img walkzero-certified-life-img-large" />
          </div>
          <div className="walkzero-certified-life-col">
            <img src="/assets/walkzero/walkzero_7.jpg" alt="Office 2" className="walkzero-certified-life-img" />
            <img src="/assets/walkzero/walk_6.jpg" alt="Meeting 2" className="walkzero-certified-life-img" />
          </div>
        </div>
      </div>
    </div>
  );
}